import React from 'react'
import { graphql, Link } from 'gatsby'
import { dasherize } from '@/utilities'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import Disclaimer from '@/components/Disclaimer'
import Credits from '@/components/Credits'
import VotacionTitle from '@/components/VotacionTitle'
import VotacionPerson from '@/components/VotacionPerson'
import { CheckCircleIcon } from '@primer/octicons-react'

const groupBy = (list, props) => {
  return list.reduce((a, b) => {
    ;(a[b[props]] = a[b[props]] || []).push(b)
    return a
  }, {})
}

const OriginTemplate = ({ data, pageContext }) => {
  const listasPorOrigen = groupBy(
    data.allGoogleSheetCandidatosConvencionConstituyenteRow.nodes,
    'distrito',
  )

  const path = `/pueblos-originarios/${dasherize(pageContext.id)}/`

  return (
    <Layout>
      <SEO title={`Lista ${pageContext.id}`} slug={path} />
      <div className="pt-16 content">
        <div className="p-3 mx-auto md:max-w-screen-sm sm:p-8">
          <h1 className="mb-4 leading-none text-center">
            Pueblo Originario: {pageContext.id}
          </h1>
          <div>
            {Object.keys(listasPorOrigen).map((distrito, i) => {
              return (
                <div key={i}>
                  <VotacionTitle className="font-bold">
                    Distrito{' '}
                    {distrito === '999' ? 'Pueblos Originarios' : distrito}
                  </VotacionTitle>
                  {listasPorOrigen[distrito].map((constituyente, index) => {
                    return (
                      <VotacionPerson
                        key={index}
                        to={`/distrito-${
                          constituyente.distrito === 999
                            ? 'pueblos-originarios'
                            : constituyente.distrito
                        }/${dasherize(constituyente.nombre)}/`}>
                        {constituyente.elegido === 'Electo' && (
                          <span className="inline-block mr-2 rounded-full svg-wrap">
                            <CheckCircleIcon
                              className="text-green "
                              size={16}
                            />
                          </span>
                        )}
                        {constituyente.elegido === 'Electo' ? (
                          <strong>{constituyente.nombrenomina} </strong>
                        ) : (
                          <span>{constituyente.nombrenomina} </span>
                        )}
                      </VotacionPerson>
                    )
                  })}
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <Disclaimer />
      <Credits />
    </Layout>
  )
}

export default OriginTemplate

export const query = graphql`
  query originQuery($id: String = "") {
    allGoogleSheetCandidatosConvencionConstituyenteRow(
      filter: { pueblooriginariosicorresponde: { eq: $id } }
    ) {
      nodes {
        nombre
        nombrenomina
        distrito
        region
        edad
        lista
        escanoreservadosino
        detalleeducacional
        pueblooriginariosicorresponde
        sexo
        militanciamilitantedepartidooindependiente
        cargoenlaconvencion
        instagram
        facebook
        correoelectronico
        partidopoliticosicorresponde
        perteneceaunpueblooriginario
        profesionuoficio
        twitter
        colegiodeegreso
        telefono
        elegido
      }
    }
  }
`
